import { Trans, useTranslation } from '@framework/i18n';
import { AlignRow } from '@framework/ui';
import { Col, Row } from 'antd';
import { down } from 'styled-breakpoints';
import { useBreakpoint } from 'styled-breakpoints/react-styled';
import styled from 'styled-components';
import { FrontFooterLogo } from './FrontFooterLogo';
import { FrontFooterNextgenerationeuLogo } from './FrontFooterNextgenerationeuLogo';
import { FrontFooterNumeroVerde } from './FrontFooterNumeroVerde';

const ContentTitle = styled.h2`
  font-size: 22px;
  line-height: 22px;
  font-weight: 600;
  padding-bottom: 0;
  ${down('md')} {
    margin-top: 32px;
  }
`;
const ContentTextLine = styled.div`
  font-size: 18px;
  line-height: 1.5;
  font-weight: 400;
  margin-bottom: 0;
  p {
    margin-bottom: 0;
  }
  strong {
    font-weight: 600;
  }
  a {
    text-decoration: underline;
    &:hover {
    }
  }
`;

export interface IFrontFooterContentProps {}
/**
 * Contenuto testuale e link del footer.
 */
export function FrontFooterContent(props: IFrontFooterContentProps) {
  const { t } = useTranslation();
  const isMobile = useBreakpoint(down('md'));

  return (
    <Row gutter={24}>
      {/* Prima colonna */}
      <Col md={6} sm={24} xs={24}>
        <FrontFooterLogo />
      </Col>
      {/* Seconda colonna */}
      <Col md={6} sm={24} xs={24}>
        <ContentTitle>
          {t('footer.address-title', 'Sede centrale MiC')}
        </ContentTitle>
        <ContentTextLine>
          <Trans t={t} i18nKey="footer.address">
            <p>Via del Collegio Romano, 27</p>
            <p>00186 Roma</p>
            <p>Centralino: (+39) 06.6723.1</p>
          </Trans>
        </ContentTextLine>
      </Col>
      <Col md={6} sm={24} xs={24}>
        <ContentTitle>
          {t(
            'footer.transparent-administration-label',
            'Amministrazione Trasparente',
          )}
        </ContentTitle>
        <a
          href="https://cultura.gov.it/numero-verde"
          target="_blank"
          rel="noreferrer"
          style={{ display: 'inline-block' }}
        >
          <FrontFooterNumeroVerde />
        </a>
      </Col>
      <Col md={6} sm={24} xs={24}>
        <ContentTitle>
          <AlignRow justify={!isMobile ? 'flex-end' : undefined}>
            <FrontFooterNextgenerationeuLogo />
          </AlignRow>
        </ContentTitle>
      </Col>
    </Row>
  );
}
